var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"500","title":"500","sub-title":"抱歉，服务器正在报告一个错误。"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v(" 回到首页 ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }